/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Productaspect2Inputs */

const de__filter_class_productaspect2 = /** @type {(inputs: _Filter_Class_Productaspect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist eines von`)
};

/**

* @param {_Filter_Class_Productaspect2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_productaspect2 = /** @type {((inputs?: _Filter_Class_Productaspect2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Productaspect2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_class_productaspect2(inputs)
});
export { _filter_class_productaspect2 as "_filter_class_ProductAspect" }